import {
  Radio, 
  Checkbox, 
  FgInput, 
  Button, 
  AcknowledgeButton,
  Dropdown, 
  Card, 
  Switch, 
  Badge, 
  Tabs, 
  TabPane,
  Collapse,
  CollapseItem
} from './components/UIComponents';

import CardHeader from '@/components/Misc/CardHeader'
import DeleteModal from '@/components/Misc/DeleteModal'
import FormButtons from '@/components/Misc/FormButtons'
import InfoCard from '@/components/Misc/InfoCard'
import RequestInfo from '@/components/Misc/RequestInfo'
import TableActionHeader from '@/components/Misc/TableActionHeader'
import SelectList from '@/components/Misc/SelectList'
import TablePagination from '@/components/Misc/TablePagination'
import Tab from '@/components/Misc/Tab'
import InfoValidityIcon from '@/components/Misc/InfoValidityIcon'
import Loading from '@/components/Misc/Loading'
import OrganisationSelect from '@/components/Timetable/OrganisationSelect'
import TButton from '@/components/Misc/TButton'
import TButtonGroup from '@/components/Misc/TButtonGroup'
import TBadge from '@/components/Misc/TBadge'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component(FgInput.name, FgInput)
    Vue.component(Dropdown.name, Dropdown)
    Vue.component(Checkbox.name, Checkbox)
    Vue.component(Radio.name, Radio)
    Vue.component(Button.name, Button)
    Vue.component(AcknowledgeButton.name, AcknowledgeButton)
    Vue.component(Card.name, Card)
    Vue.component(Switch.name, Switch)
    Vue.component(Badge.name, Badge)
    Vue.component(Tabs.name, Tabs)
    Vue.component(TabPane.name, TabPane)
    Vue.component(Collapse.name, Collapse)
    Vue.component(CollapseItem.name, CollapseItem)

    Vue.component(CardHeader.name, CardHeader)
    Vue.component(DeleteModal.name, DeleteModal)
    Vue.component(FormButtons.name, FormButtons)
    Vue.component(InfoCard.name, InfoCard)
    Vue.component(RequestInfo.name, RequestInfo)
    Vue.component(SelectList.name, SelectList)
    Vue.component(TableActionHeader.name, TableActionHeader)
    Vue.component(TablePagination.name, TablePagination)
    Vue.component(Tab.name, Tab)
    Vue.component(InfoValidityIcon.name, InfoValidityIcon)
    Vue.component(Loading.name, Loading)
    Vue.component(OrganisationSelect.name, OrganisationSelect)
    Vue.component(TButton.name, TButton)
    Vue.component(TButtonGroup.name, TButtonGroup)
    Vue.component(TBadge.name, TBadge)
  
  }
}

export default GlobalComponents
